(function () {
  const root = document.querySelector('[data-mdock]');
  if (!root) return;

  const trigger = root.querySelector('[data-mdock-trigger]');
  const overlay = root.querySelector('[data-mdock-overlay]');
  const panel = root.querySelector('[data-mdock-panel]');
  const body = root.querySelector('[data-mdock-body]');
  const backBtn = root.querySelector('[data-mdock-back]');
  const searchInput = root.querySelector('[data-mdock-search]');
  const searchResults = root.querySelector('[data-mdock-search-results]');

  // Elementos obrigatórios
  if (!trigger || !overlay || !panel || !body || !backBtn || !searchInput) {
    console.warn('[mdock] Elementos obrigatórios não encontrados no DOM.');
    return;
  }

  // Lê menus embutidos via Liquid
  const jsonEl = root.querySelector('[data-mdock-json]');
  let MENUS = { root: [], icons: [] };

  try {
    MENUS = jsonEl ? JSON.parse(jsonEl.textContent || '{}') : MENUS;
  } catch (e) {
    console.warn('[mdock] JSON inválido em data-mdock-json', e);
    MENUS = { root: [], icons: [] };
  }

  const stack = [];

  // ===== Helpers =====
  function getTitle(item) {
    return item?.title ?? item?.name ?? item?.text ?? item?.label ?? 'Item';
  }
  function getUrl(item) {
    return item?.url ?? item?.link ?? item?.href ?? '#';
  }
  function getChildren(item) {
    const c = item?.links ?? item?.items ?? item?.children ?? [];
    return Array.isArray(c) ? c : [];
  }

  function escapeHtml(str) {
    return String(str ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function slugifyForAsset(str) {
    return String(str ?? '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getAutoAssetUrl(item) {
    const base = window.MDOCK_ASSET_BASE || '';
    if (!base) return '';
    const raw = item?.handle || item?.title || item?.name;
    const key = slugifyForAsset(raw);
    if (!key) return '';
    return base + `icon-${key}.svg`;
  }

  // ===== Predictive Search state =====
  let psAbort = null;
  let psTimer = null;

  function buildViewAllUrl(q) {
    const qs = new URLSearchParams({ q });
    return `/search?${qs.toString()}`;
  }

  // ===== Open / Close =====
  function open() {
    root.classList.add('is-open');
    overlay.hidden = false;
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';

    if (searchResults) {
      searchResults.hidden = true;
      searchResults.innerHTML = '';
    }
  }

  function close() {
    root.classList.remove('is-open');
    overlay.hidden = true;
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    stack.length = 0;
    backBtn.hidden = true;
    searchInput.value = '';
    body.innerHTML = '';

    if (searchResults) {
      searchResults.hidden = true;
      searchResults.innerHTML = '';
    }
  }

  // ===== Render List =====
  function renderList(title, items) {
    body.innerHTML = '';

    if (searchResults) {
      searchResults.hidden = true;
      searchResults.innerHTML = '';
    }

    const list = document.createElement('div');
    list.className = 'mdock__list';

    (items || []).forEach((item) => {
      const children = getChildren(item);
      const hasChildren = children.length > 0;

      const titleText = getTitle(item);
      const url = getUrl(item);

      let el;

      if (hasChildren) {
        el = document.createElement('button');
        el.type = 'button';
        el.className = 'mdock__item';
        el.innerHTML = `
          <span>${escapeHtml(titleText)}</span>
          <span class="mdock__chev">›</span>
        `;

        el.addEventListener('click', () => {
          const next = children;

          const nextIsLeafGrid =
            next.length > 0 && next.every((x) => getChildren(x).length === 0);

          stack.push({ type: 'list', title, items });
          backBtn.hidden = false;

          if (nextIsLeafGrid) {
            renderGrid(titleText, next);
          } else {
            renderList(titleText, next);
          }
        });
      } else {
        el = document.createElement('a');
        el.className = 'mdock__item';
        el.href = url;
        el.innerHTML = `
          <span>${escapeHtml(titleText)}</span>
          <span class="mdock__chev"></span>
        `;
      }

      list.appendChild(el);
    });

    body.appendChild(list);
  }

  // ===== Render Grid =====
  function renderGrid(title, items) {
    body.innerHTML = '';

    const h = document.createElement('div');
    h.className = 'mdock__gridTitle';
    h.textContent = title;

    const grid = document.createElement('div');
    grid.className = 'mdock__grid';

    (items || []).forEach((item) => {
      const a = document.createElement('a');
      a.className = 'mdock__card';
      a.href = getUrl(item);

      const cardTitle = getTitle(item);
      const imgUrl = item?.image || item?.img || item?.thumbnail || getAutoAssetUrl(item);

      a.innerHTML = `
        <div class="mdock__thumb">
          <img class="mdock__thumbImg" alt="${escapeHtml(cardTitle)}" loading="lazy">
        </div>
        <div class="mdock__name">${escapeHtml(cardTitle)}</div>
      `;

      const img = a.querySelector('.mdock__thumbImg');

      if (imgUrl) {
        img.src = imgUrl;
        img.onerror = () => {
          img.remove();
          const ph = document.createElement('div');
          ph.className = 'mdock__thumbPh';
          ph.textContent = '';
          a.querySelector('.mdock__thumb')?.appendChild(ph);
        };
      } else {
        img.remove();
      }

      grid.appendChild(a);
    });

    body.appendChild(h);
    body.appendChild(grid);
  }

  // ===== Predictive Search =====
  async function applySearch(q) {
    if (!searchResults) return;

    q = (q || '').trim();
    if (q.length < 2) {
      searchResults.hidden = true;
      searchResults.innerHTML = '';
      return;
    }

    // debounce
    clearTimeout(psTimer);
    psTimer = setTimeout(async () => {
      if (psAbort) psAbort.abort();
      psAbort = new AbortController();

      const params = new URLSearchParams();
      params.set('q', q);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '6');
      params.set('resources[options][unavailable_products]', 'hide');

      const url = `/search/suggest.json?${params.toString()}`;

      searchResults.hidden = false;
      searchResults.innerHTML = `<div style="padding:10px;opacity:.7;font-size:13px;">Searching…</div>`;

      try {
        const res = await fetch(url, {
          signal: psAbort.signal,
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();

        const products = data?.resources?.results?.products || [];

        if (!products.length) {
          searchResults.innerHTML = `
            <div style="padding:10px;opacity:.7;font-size:13px;">No results</div>
            <div class="mdock__psFooter">
              <a class="mdock__psBtn" href="${buildViewAllUrl(q)}">View all</a>
            </div>
          `;
          return;
        }

        const itemsHtml = products.map(p => {
          const title = p?.title || 'Product';
          const href = p?.url || buildViewAllUrl(q);
          const img = p?.featured_image?.url || p?.image || '';
          const meta = p?.product_type || '';

          return `
            <a class="mdock__psItem" href="${escapeHtml(href)}">
              <span class="mdock__psThumb">
                ${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(title)}" loading="lazy">` : ``}
              </span>
              <span class="mdock__psText">
                <span class="mdock__psTitle">${escapeHtml(title)}</span>
                <span class="mdock__psMeta">${escapeHtml(meta)}</span>
              </span>
            </a>
          `;
        }).join('');

        searchResults.innerHTML = `
          ${itemsHtml}
          <div class="mdock__psFooter">
            <a class="mdock__psBtn" href="${buildViewAllUrl(q)}">View all</a>
          </div>
        `;

        // Clicar em resultado fecha o menu
        searchResults.querySelectorAll('a').forEach(a => {
          a.addEventListener('click', () => close());
        });

      } catch (err) {
        if (err.name === 'AbortError') return;
        console.warn('[mdock] predictive search error', err);
        searchResults.innerHTML = `
          <div style="padding:10px;opacity:.7;font-size:13px;">Search error</div>
          <div class="mdock__psFooter">
            <a class="mdock__psBtn" href="${buildViewAllUrl(q)}">View all</a>
          </div>
        `;
      }
      





         
    }, 150);
  }

  // ===== Events =====
  backBtn.addEventListener('click', () => {
    const prev = stack.pop();
    if (!prev) {
      backBtn.hidden = true;
      return;
    }
    if (prev.type === 'list') renderList(prev.title, prev.items);
    if (!stack.length) backBtn.hidden = true;
  });

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    open();
    renderList('Menu', MENUS.root || []);
  });

  overlay.addEventListener('click', close);

  // 
  panel.addEventListener('click', (e) => e.stopPropagation());
  root.querySelector('.mdock__sheet')?.addEventListener('click', (e) => e.stopPropagation());

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  searchInput.addEventListener('input', (e) => applySearch(e.target.value));

  //  Esconder resultados se apagar tudo
  searchInput.addEventListener('blur', () => {
    setTimeout(() => {
      if (searchResults && !searchInput.value.trim()) {
        searchResults.hidden = true;
        searchResults.innerHTML = '';
      }
    }, 200);
  });
})();





